'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (centerX, centerY, scale) {
  var gl = store.get('gl');
  gl.hexagonalPixelate = gl.hexagonalPixelate || new _shader2.default(null, '\
    uniform sampler2D texture;\
    uniform vec2 center;\
    uniform float scale;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    void main() {\
      vec2 tex = (texCoord * texSize - center) / scale;\
      tex.y /= 0.866025404;\
      tex.x -= tex.y * 0.5;\
      \
      vec2 a;\
      if (tex.x + tex.y - floor(tex.x) - floor(tex.y) < 1.0) a = vec2(floor(tex.x), floor(tex.y));\
      else a = vec2(ceil(tex.x), ceil(tex.y));\
      vec2 b = vec2(ceil(tex.x), floor(tex.y));\
      vec2 c = vec2(floor(tex.x), ceil(tex.y));\
      \
      vec3 TEX = vec3(tex.x, tex.y, 1.0 - tex.x - tex.y);\
      vec3 A = vec3(a.x, a.y, 1.0 - a.x - a.y);\
      vec3 B = vec3(b.x, b.y, 1.0 - b.x - b.y);\
      vec3 C = vec3(c.x, c.y, 1.0 - c.x - c.y);\
      \
      float alen = length(TEX - A);\
      float blen = length(TEX - B);\
      float clen = length(TEX - C);\
      \
      vec2 choice;\
      if (alen < blen) {\
        if (alen < clen) choice = a;\
        else choice = c;\
      } else {\
        if (blen < clen) choice = b;\
        else choice = c;\
      }\
      \
      choice.x += choice.y * 0.5;\
      choice.y *= 0.866025404;\
      choice *= scale / texSize;\
      gl_FragColor = texture2D(texture, choice + center / texSize);\
    }\
  ');

  _util.simpleShader.call(this, gl.hexagonalPixelate, {
    center: [centerX, centerY],
    scale: scale,
    texSize: [this.width, this.height]
  });

  return this;
};

var _shader = require('../../shader');

var _shader2 = _interopRequireDefault(_shader);

var _util = require('../../util');

var _store = require('../../store');

var store = _interopRequireWildcard(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }